(function () {
  /**
   * PrintTableTemplates - this module returns All the html builders for the
   * Types of printing available
   *
   * @returns {Object}  An object,each with the body of the view and the path
   * to the row-worker needed for the rows
   */
  function PrintTableTemplates() {
    /**
     * These are the paths to the workers you need to render
     * rows for each view.
     */
    const appState = BatchGeoStore.getState().App;

    var gridWorkerPath = appState.printGridWorkerUrl;
    var listWorkerPath = appState.printListWorkerUrl;

    /**
     * tableGridHtml - This returns the html you need if the user selects
     * the 'advanced grid' way of printing.
     *
     * @param   {Array.<String>} columns A list of the column names
     * @returns {String}                 A string of well formed html
     */
    function tableGridHtml(columns) {
      function colToHtml(name, index) {
        var text = name.replace(/ /g, "&nbsp;");
        return '<th data-position="' + index + '">' + text + "</th>";
      }

      function columnsToHtml(columns) {
        return columns.map(colToHtml).join("");
      }

      var html =
        '<table class="batchgeo-print-table batchgeo-print-table-grid-view">' +
        '<thead class="">' +
        "<tr>" +
        columnsToHtml(columns) +
        "</tr>" +
        "</thead>" +
        '<tbody class="batchgeo-print-table-body">' +
        "</tbody>" +
        "</table>";

      return html;
    }

    /**
     * tableListHtml -    This returns the html you will
     * need if a user selects 'list'
     *
     * @returns {String}  A string of well formed html
     */
    function tableListHtml() {
      return (
        '<div class="batchgeo-print-table batchgeo-print-table-list-view">' +
        '<div class="batchgeo-print-table-body"></div>' +
        "</div>"
      );
    }

    return {
      grid: {
        body: tableGridHtml,
        rowWorker: gridWorkerPath,
      },
      list: {
        body: tableListHtml,
        rowWorker: listWorkerPath,
      },
    };
  }

  window.PrintTableTemplates = PrintTableTemplates;
})();
